/* eslint-disable */

import type { OnboardingLang } from "./types/OnboardingLang";

let data: OnboardingLang | undefined;

export type { OnboardingLang };

export default function OnboardingLangFactory(): OnboardingLang {
  if (!data) {
    throw new Error("Trying to load a language in the main bundle before the language bundle is loaded");
  }
  return data;
}

export let setOnboardingLang = (newLang: string) => {
  if (newLang === "en-GB") {
      return import(/* webpackChunkName: "en-GB.locale" */ "./en-GB/OnboardingLangDef").then(({ OnboardingLangDef }) => {
      data = OnboardingLangDef;
    });
  } else if (newLang === "sv-SE") {
      return import(/* webpackChunkName: "sv-SE.locale" */ "./sv-SE/OnboardingLangDef").then(({ OnboardingLangDef }) => {
      data = OnboardingLangDef;
    });
  } else if (newLang === "en-SE") {
      return import(/* webpackChunkName: "en-SE.locale" */ "./en-SE/OnboardingLangDef").then(({ OnboardingLangDef }) => {
      data = OnboardingLangDef;
    });
  } else if (newLang === "ky-KG") {
      return import(/* webpackChunkName: "ky-KG.locale" */ "./ky-KG/OnboardingLangDef").then(({ OnboardingLangDef }) => {
      data = OnboardingLangDef;
    });
  }
  else {
    throw new Error("Unsupported language/culture " + newLang);
  }
};

